// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendor-products-tab {
  animation: fadeIn 0.5s ease-in-out;
}

.tab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.tab-header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.add-product-btn {
  background-color: #f97316;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.add-product-btn:hover {
  background-color: #ea580c;
}

.tab--empty {
  text-align: center;
  padding: 60px 20px;
  background-color: #fff;
  border-radius: 12px;
}

.tab--empty img {
  width: 100px;
  margin-bottom: 20px;
  opacity: 0.7;
}

.tab--empty p {
  font-size: 16px;
  color: #6b7280;
}

.product-actions {
  display: flex;
  gap: 16px;
  align-items: center;
}

.product-actions .action-icon {
  width: 20px;
  height: 20px;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}
.status-active {
  background-color: #def7ec;
  color: #046c4e;
}
.status-inactive {
  background-color: #fef3c7;
  color: #92400e;
}

.details-tabs {
  border-bottom: 2px solid #f3f4f6;
  margin-bottom: 30px;
}

.details-tabs button {
  background: none;
  border: none;
  padding: 0 5px 15px 5px;
  margin-right: 30px;
  font-size: 16px;
  color: #6b7280;
  cursor: pointer;
  position: relative;
  font-weight: 500;
}

.details-tabs button.active {
  color: #f97316;
  font-weight: 600;
}

.details-tabs button.active::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #f97316;
}

.details-content {
  background-color: transparent;
  padding: 0;
  border-radius: 0;
}
`, "",{"version":3,"sources":["webpack://./src/compoonents/VendorProductsTab/VendorProductsTab.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,gBAAgB;AAClB","sourcesContent":[".vendor-products-tab {\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n.tab-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.tab-header h4 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.add-product-btn {\n  background-color: #f97316;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.add-product-btn:hover {\n  background-color: #ea580c;\n}\n\n.tab--empty {\n  text-align: center;\n  padding: 60px 20px;\n  background-color: #fff;\n  border-radius: 12px;\n}\n\n.tab--empty img {\n  width: 100px;\n  margin-bottom: 20px;\n  opacity: 0.7;\n}\n\n.tab--empty p {\n  font-size: 16px;\n  color: #6b7280;\n}\n\n.product-actions {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.product-actions .action-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n.status-active {\n  background-color: #def7ec;\n  color: #046c4e;\n}\n.status-inactive {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.details-tabs {\n  border-bottom: 2px solid #f3f4f6;\n  margin-bottom: 30px;\n}\n\n.details-tabs button {\n  background: none;\n  border: none;\n  padding: 0 5px 15px 5px;\n  margin-right: 30px;\n  font-size: 16px;\n  color: #6b7280;\n  cursor: pointer;\n  position: relative;\n  font-weight: 500;\n}\n\n.details-tabs button.active {\n  color: #f97316;\n  font-weight: 600;\n}\n\n.details-tabs button.active::after {\n  content: \"\";\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #f97316;\n}\n\n.details-content {\n  background-color: transparent;\n  padding: 0;\n  border-radius: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
